import { useCallback } from 'react';
import { DateString, EventKeyed } from '../../contexts/EventsLazyContext';
import {
  EventsFetcher,
  QueryEvents,
} from '../../../functions/src/util/tournaments/EventsFetcher';
import type { DocumentData, Query } from 'firebase/firestore';

export type UseEventsFetcherParams<
  TEvent extends { id: string; date: Date } & Record<string, unknown>,
> = {
  sortEachDay: (
    eventsByDay: Record<string, TEvent[]>,
  ) => Record<string, EventKeyed[]>;
  gameIds: 'ALL' | string[];
  queryEvents: QueryEvents<TEvent, Query<DocumentData>>;
};

export const useEventsFetcher = <
  TEvent extends { id: string; date: Date } & Record<string, unknown>,
>({
  sortEachDay,
  queryEvents,
  gameIds,
}: UseEventsFetcherParams<TEvent>) => {
  const fetchEvents = useCallback(
    async (startDate: DateString, endDate: DateString = startDate) => {
      const eventsFetcher = new EventsFetcher(queryEvents);
      const eventsByDay = await eventsFetcher.fetch(
        gameIds,
        startDate,
        endDate,
      );
      return sortEachDay(eventsByDay);
    },
    [gameIds, queryEvents, sortEachDay],
  );
  return { fetchEvents };
};
